@import "@/scss/use-bootstrap-mixins.scss";

.baseModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .card {
    background: white;
    max-width: 600px;
    max-height: 100vh;
    overflow-y: auto;
    padding: 16px 16px 16px 16px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    .close {
      display: flex;
      justify-content: flex-end;

      .closeButton {
        background: none;
        width: 28px;
        height: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        svg.closeIcon {
          stroke: #666;
        }
      }
    }
  }
}
